module.exports = __webpack_public_path__ + "static/media/plus_circular_outlined.a96569a9.svg";